import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../../../../../contexts/Auth";

import api from "../../../../../../services/api";

import RestricaoEquipe from "./RestricaoEquipe";
import { MenuComportamento } from "../../../../../../components/Menus";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import { Badge, Button, ButtonGroup, Row, Col, Modal } from "reactstrap";


import classnames from "classnames";

import Users from "./Users";
import Perfis from "../../../../../security/Users/empresas/perfis";
import EmpresaContext from "../../../../../../contexts/Empresa";
import { EquipeTrabalho } from "./EquipeTrabalho";
import { NovoCanalModal } from "./NovoCanal/NovoCanalModal";
import { any } from "prop-types";

export default ({ notify, empresa, equipes, loadEquipes, setOnNovo, isActive, setHeaderExtra, ...props }) => {
  const { auth, user } = useContext(AuthContext);
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [colaboradores, setColaboradores] = useState([]);
  const [colaborador, setColaborador] = useState(null);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);

  const [situacao, setSituacao] = useState("ativo");
  const [situacaoNaEmpresa, setSituacaoNaEmpresa] = useState("A");

  const [colaboradorSelecionado, setColaboradorSelecionado] = useState(null);

  const [showRestricaoEquipe, setShowRestricaoEquipe] = useState(undefined);
  const [showEquipesTrabalho, setShowEquipesTrabalho] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [showPerfis, setShowPerfis] = useState(false);
  const [showRecoveryModal, setShowRecoveryModal] = useState(false);
  const [recoveryLink, setRecoveryLink] = useState("");
  const [loadingRecoveryModal, setLoadingRecoveryModal] = useState(false);
  // const [equipes, setEquipes] = useState([]);
  // No início do componente (junto com os outros estados)
  const [showNovoCanalModal, setShowNovoCanalModal] = useState(false);

  const [colaboradorParaCanal, setColaboradorParaCanal] = useState(null);
  const [canaisDisponiveis, setCanaisDisponiveis] = useState([]);

  const [loadingCanais, setLoadingCanais] = useState(true);
  const [accounts, setAccounts] = useState([]);
  
  const columns = React.useMemo(() => [
    {
      dataField: "acoes",
      formatter: (cell, row) => acoesFormatter(cell, row),
    },
    {
      dataField: "name",
      text: "Nome",
      sort: true,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "userEmpresa",
      text: "Situação",
      sort: true,
      formatter: (cell, row) => situacaoFormatter(cell, row),
    },
    {
      dataField: "canais",
      text: "Canais",
      align: "center",
      headerAlign: "center",
      // Passe o estado 'accounts' diretamente para o formatador
      formatter: (cell, row) => canaisFormatter(row, accounts),
    },
    {
      dataField: "roles",
      text: "Perfis",
      align: "center",
      headerAlign: "center",
      formatter: (cell, row) => rolesFormaters(cell, row),
    },
  ], [accounts]); // Array de dependências: Recria as colunas quando 'accounts' mudar

  // useEffect(() => {
  //   if (colaboradores.length === 0) loadColaboradores();
  // }, []);

  useEffect(() => {
    loadColaboradores();
  }, [situacaoNaEmpresa]);

  useEffect(() => {
    fetchAccounts();

  }, [empresaSelecionada.id]);

  useEffect(() => {
    if (isActive && setOnNovo) {
      setOnNovo(() => openAddUsers);
    }
  }, [isActive, setOnNovo]);

  useEffect(() => {
    if (isActive && setHeaderExtra) {
      setHeaderExtra(
        <ButtonGroup
          className="btn-group-toggle"
          size="sm"
          data-toggle="buttons"
        >
          {[
            { id: "", text: "Todos" },
            { id: "A", text: "Ativos" },
            { id: "I", text: "Inativos" },
          ].map((item, key) => (
            <Button
              key={key}
              className={classnames({ active: situacaoNaEmpresa == item.id })}
              color="secondary"
              onClick={() => setSituacaoNaEmpresa(item.id)}
            >
              {item.text}
            </Button>
          ))}
        </ButtonGroup>
      );
      return () => setHeaderExtra(null);
    }
  }, [isActive, setHeaderExtra, situacaoNaEmpresa]);

  useEffect(() => {
    const loadCanais = async () => {
      try {
        const { data } = await api.get('/marketing/canais');
        setCanaisDisponiveis(data.filter(c => c.is_canal_contato));
      } catch (error) {
        console.error("Erro ao carregar canais:", error);
      }
    };
    loadCanais();
  }, []);

  // useEffect(() => {
  //   if (equipes.length === 0) loadEquipes();
  // }, [empresa]);

  // async function loadEquipes() {
  //   try {
  //     const response = await api.get(`/common/empresas/${empresa.id}/equipes`);
  //     const equipesCaptacao = response.data.filter(
  //       (equipe) => equipe.captadora == "I"
  //     );
  //     setEquipes(equipesCaptacao);
  //   } catch (error) {
  //     console.error(error);
  //     notify("danger", "Não foi possível carregar equipes");
  //   }
  // }


  async function fetchAccounts() {
          try {
            const { data } = await api.get(`/meta/all-accounts/empresa/${empresaSelecionada.id}`);
  
            setAccounts(data || [])
            
            
        }  catch (err) {
            console.error("Erro ao carregar contas Meta:", err)
        }  
      }

  const handleSaveNovoCanal = async ({ canalId, identificador }) => {
    try {
      await api.post(
        `/common/empresas/${empresaSelecionada.id}/colaboradores/${colaboradorParaCanal.id}/canais-contato`,
        {
          canal_id: canalId,
          identificador
        }
      );

      notify('success', 'Canal adicionado com sucesso!');
      loadColaboradores();
    } catch (error) {

      notify('danger', 'Erro ao adicionar canal');
      console.error('Erro ao adicionar canal:', error);
    }
  };

  

function canaisFormatter(row, accounts) {
  const canaisMap = {
    25: { icon: "whatsapp", color: "#25D366", label: "WhatsApp" },
    12: { icon: "envelope", color: "#EA4335", label: "E-mail" },
    2: { icon: "instagram", color: "#E4405F", label: "Instagram" }
  };

  return (
    <div style={{
      display: 'flex',
      gap: '12px',
      justifyContent: 'center',
      fontSize: '1.4rem',
      position: 'relative'
    }}>
      {Object.entries(canaisMap).map(([id, config]) => {
        
        const canalDoUsuario = row.canaisContato?.find(
          canal => canal.canal_id == id
        );

        const exists = !!canalDoUsuario;

        let titleText = `${config.label} não cadastrado`;
        if (exists) {
          titleText = `${config.label}: ${canalDoUsuario.identificador}`;
        }

        const isMetaAccountAtivo = accounts?.some(
          account => account.user_id === row.id && account.situacao === 'A'
        );

        return (
          <div key={id} style={{ position: 'relative' }}>
            <i
              className={`fa${config.icon === 'envelope' ? 's' : 'b'} fa-${config.icon}`}
              title={titleText}
              style={{
                color: exists ? config.color : '#ADB5BD',
                opacity: exists ? 1 : 0.5,
                cursor: 'pointer',
                transition: 'all 0.3s'
              }}
              onClick={() => {
                if (!exists) {
                  setColaboradorParaCanal(row);
                  setShowNovoCanalModal(true);
                }
              }}
            />
            {!exists && (
              <i
                className="fas fa-plus-circle"
                style={{
                  position: 'absolute',
                  bottom: '-5px',
                  right: '-5px',
                  fontSize: '0.8rem',
                  color: '#2dce89'
                }}
              />
            )}
            
            {(isMetaAccountAtivo && id == 25) && (
              <i
                className="fas fa-check-circle"
                style={{
                  position: 'absolute',
                  bottom: '-5px',
                  right: '-5px',
                  fontSize: '0.8rem',
                  color: '#2dce89',
                  backgroundColor: 'white',
                  borderRadius: '50%'
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
// ...existing code...

  async function loadColaboradores() {
    try {
      let url = new URLSearchParams();
      situacao && url.set("situacao", situacao);
      situacaoNaEmpresa && url.set("situacaoNaEmpresa", situacaoNaEmpresa);
      const { data } = await api.get(
        `/common/empresas/${empresaSelecionada?.id
        }/colaboradores?${url.toString()}`
      );

      if (data) {
        setColaboradores(data);
      }
    } catch (error) {
      console.log(error);
      notify("danger", "Não foi possível carregar os colaboradores");
    }
  }

  function rolesFormaters(cell, row) {
    return (
      <>
        {row.roles.map((item, key) => (
          <>
            <Badge key={key} className="badge-default" pill>
              {item.name}
            </Badge>
          </>
        ))}
      </>
    );
  }

  function situacaoFormatter(cell, row) {
    return row.userEmpresas[0].situacao == "I" ? "Inativo" : "Ativo";
  }

  async function updateColaboradorSituacao(userId, situacaoAtual) {
    setLoading(true);
    try {
      await api.patch(
        `/common/empresas/${empresa.id}/colaboradores/${userId}/${situacaoAtual}`
      );
      loadColaboradores();

      notify("success", "Colaborador removido");
    } catch (error) {
      console.log(error);
      notify("danger", "Não foi possível remover colaborador");
    }
    setLoading(false);
    setAlert(null);
  }

  function handleSituacaoColaboradorNaEmpresa(colaborador) {
    const isActive = colaborador.userEmpresas[0].situacao == "A";

    confirmAlert(
      `Deseja realmente inativar ${colaborador.name} na empresa ${empresa.nome}? Antes de prosseguir, certifique-se de que ${colaborador.name} não está atualmente associado(a) a nenhuma equipe, programa de indicação ou possui oportunidades em aberto no sistema. Isso nos ajudará a garantir que o processo de remoção seja realizado corretamente, evitando impactos indesejados.`,
      "danger",
      () => updateColaboradorSituacao(colaborador.id, isActive ? "I" : "A")
    );
  }

  function handleEditPerfil(colaborador) {
    setColaboradorSelecionado(colaborador);
    setShowPerfis(true);
  }

  function handleEditEquipe(colaborador) {
    setColaboradorSelecionado(colaborador);
    setShowEquipesTrabalho(true);
  }

  function confirmAlert(message, alertColor, onConfirm) {
    setAlert(
      <Modal
        className={`modal-dialog-centered modal-${alertColor}`}
        contentClassName={`bg-gradient-${alertColor}`}
        isOpen={true}
        toggle={() => setAlert(null)}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-notification">
            Atenção
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => setAlert(null)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="fas fa-question-circle ni-3x" />
            <br />
            <br />
            <p>{message}</p>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            className="btn-white"
            color="default"
            type="button"
            onClick={onConfirm}
          >
            Sim
          </Button>
          <Button
            className="text-white ml-auto"
            color="link"
            data-dismiss="modal"
            type="button"
            onClick={() => setAlert(null)}
          >
            Fechar
          </Button>
        </div>
      </Modal>
    );
  }

  async function handleGenerateRecoveryLink(colaborador) {
    setColaboradorSelecionado(colaborador);
    setShowRecoveryModal(true);
    setLoadingRecoveryModal(true);
    setRecoveryLink("");

    try {
      const { data } = await api.post(
        `/common/empresas/${empresaSelecionada?.id}/colaboradores/${colaborador.id}/recovery-link`
      );
      const fullUrl = `${window.location.origin}${data.path}`;
      setRecoveryLink(fullUrl);
    } catch (error) {
      console.error(error);
      notify("danger", "Não foi possível gerar o link de recuperação de senha.");
      setShowRecoveryModal(false);
    } finally {
      setLoadingRecoveryModal(false);
    }
  }

  function copyRecoveryLink() {
    navigator.clipboard.writeText(recoveryLink);
    notify("success", "Link copiado para a área de transferência!");
  }

  function acoesFormatter(cell, row) {
    const isActive = row.userEmpresas[0].situacao == "A";
    const actions = [
      {
        label: "Editar Perfis",
        icon: "fas fa-user-tag",
        onClick: () => handleEditPerfil(row),
      },
      {
        label: "Equipe de Trabalho",
        icon: "fas fa-users",
        onClick: () => handleEditEquipe(row),
      },
      {
        label: "Restrição de equipes",
        icon: "fas fa-times",
        onClick: () => setShowRestricaoEquipe(row),
      },
      ...(user.roles?.find(role => role.slug === "administrador_empresa") || user.roles?.find(role => role.slug === "gestor_comercial") ? [
        {
          label: "Recuperação de senha",
          icon: "fas fa-key",
          onClick: () => handleGenerateRecoveryLink(row),
        }
      ] : []),
      {
        label: isActive ? "Inativar" : "Ativar",
        icon: isActive ? "fas fa-trash" : "fas fa-plus",
        onClick: () => handleSituacaoColaboradorNaEmpresa(row),
      },
    ];

    return (
      <>
        <MenuComportamento direction="right" actions={actions} />
      </>
    );
  }

  function clienteOptions() {
    const option = {
      placeholder: "Selecione um usuário para ser um colaborador...",
      width: 300,
    };
    option["ajax"] = {
      url: `${process.env.REACT_APP_API_URL}/common/empresas/${empresa.id}/colaboradores?withNotEmpresa=true`,
      dataType: "json",
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
      processResults: function (data) {
        return {
          results: data.map((item) => ({
            id: item.id,
            text: `${item.name}, ${item.email}`,
          })),
        };
      },
    };
    return option;
  }

  function openAddUsers() {
    setShowUsers(true);
  }

  function hideUsers() {
    setShowUsers(false);
  }

  function hidePerfis() {
    setColaboradorSelecionado(null);
    setShowPerfis(false);
  }

  const situacoes = [
    { id: "", text: "Todos" },
    { id: "A", text: "Ativos" },
    { id: "I", text: "Inativos" },
  ];



  return (
    <>
      {alert}
      <div className="py-0 table-responsive overflow-hidden">
        <RestricaoEquipe
          notify={notify}
          empresa={empresa}
          show={!!showRestricaoEquipe}
          hidde={() => setShowRestricaoEquipe(undefined)}
          user={showRestricaoEquipe}
        />
        {/* Adicione isto junto com os outros modais */}
        <NovoCanalModal
          isOpen={showNovoCanalModal}
          onClose={() => {
            setShowNovoCanalModal(false);
            setColaboradorParaCanal(null);
          }}
          onSave={handleSaveNovoCanal}
          canais={canaisDisponiveis}
          isLoading={loading}
          googleLogin={() => {/* implementação do googleLogin */ }}
          isColaborador={true}
          empresaId={empresaSelecionada?.id}
          colaboradorId={colaboradorParaCanal?.id}
          loadColaboradores={loadColaboradores}
        />

        <Users
          empresa={empresa}
          hide={hideUsers}
          notify={notify}
          show={showUsers}
          loadColaboradores={loadColaboradores}
        />

        <Perfis
          empresa={empresa}
          hide={hidePerfis}
          notify={notify}
          show={showPerfis}
          user={colaboradorSelecionado}
          naoMostrarInvisiveis={true}
          loadColaboradores={loadColaboradores}
        />

        <EquipeTrabalho
          isOpen={showEquipesTrabalho}
          colaborador={colaboradorSelecionado}
          loadEquipes={loadEquipes}
          equipes={equipes.filter(equipe => equipe.captadora == 'I')}
          onClose={() => setShowEquipesTrabalho(false)}
        />

        <Modal
          className="modal-dialog-centered"
          isOpen={showRecoveryModal}
          toggle={() => setShowRecoveryModal(false)}
        >
          <div className="modal-header">
            <h6 className="modal-title" id="modal-title-default">
              Link de Recuperação de Senha
            </h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setShowRecoveryModal(false)}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {loadingRecoveryModal ? (
              <div className="text-center">
                <h5>Gerando link...</h5>
              </div>
            ) : (
              <div>
                <p>O link de recuperação para o usuário <strong>{colaboradorSelecionado?.name}</strong> foi gerado com sucesso.</p>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    value={recoveryLink}
                    readOnly
                  />
                  <div className="input-group-append">
                    <Button color="primary" onClick={copyRecoveryLink}>
                      Copiar
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
            <Button
              className="ml-auto"
              color="link"
              data-dismiss="modal"
              type="button"
              onClick={() => setShowRecoveryModal(false)}
            >
              Fechar
            </Button>
          </div>
        </Modal>

        {/* Removed local Novo button, now in parent header */}

        {/* ================ */}
        {/* Removed local status filters, now in parent header */}

        {/* =========================== */}
        <Row>
          <Col className="col-12">
            <ToolkitProvider
              data={colaboradores}
              keyField="name"
              columns={columns}
              search
            >
              {(props) => (
                <div className="py-4">
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4={true}
                    bordered={false}
                    classes="table-sm table-v-middle"
                    condensed
                  />
                </div>
              )}
            </ToolkitProvider>
          </Col>
        </Row>
      </div>
    </>
  );
};
